<template>
  <loading v-if="loading" />
  <form-multiselect
    v-else
    :show-valid-tick="false"
    :show-drop-icon="true"
    ref="filter"
    long
    autocomplete="off"
    placeholder="All"
    v-model="filterQuery"
    :options="banners"
    :multiple="false"
    label="name"
    track-by="name"
    :searchable="true"
    @input="filter"
    :limit="1"
  />
</template>

<script>
export default {
  name: "AnnouncementBannerSelect",
  data() {
    return {
      banners: null,
      selected: null,
      loading: true,
      filterQuery: null,
    };
  },
  methods: {
    filter(val) {
      this.$emit("input", val.id);
    },
  },
  async mounted() {
    try {
      this.banners = await this.$store.dispatch("Banner/listSliders", { flat: true });
      this.loading = false;
    } catch (err) {
      this.loading = false;
    }
  },
};
</script>

<style lang="scss" scoped></style>
